import { BasicLayout, BlankLayout } from '@/layout'

const systemRouter = {
  path: '/system',
  name: 'System',
  alwaysShow: true,
  component: BasicLayout,
  redirect: 'noRedirect',
  meta: { title: '系统管理', icon: 'el-icon-s-tools' },
  children: [
    {
      path: 'index',
      name: 'SystemIndex',
      meta: { title: '系统配置' },
      component: () => import('@/views/system/index')
    },
    {
      path: 'operation',
      name: 'Operation',
      redirect: 'noRedirect',
      meta: { title: '权限管理' },
      component: BlankLayout, // Parent router-view
      children: [
        {
          path: 'permission',
          name: 'PermissionManager',
          meta: { title: '权限规则' },
          component: () => import('@/views/system/operation/permission')
        },
        {
          path: 'role',
          name: 'RoleManager',
          meta: { title: '角色管理' },
          component: () => import('@/views/system/operation/role')
        },
        {
          path: 'admin',
          name: 'AdminManager',
          meta: { title: '操作员管理' },
          component: () => import('@/views/system/operation/admin')
        }
      ]
    }
  ]
}

export default systemRouter
